<app-default-main-layout>
  <div class="container">
    <div class="row">
      <div class="col-12" [innerHtml]="body"></div>
    </div>
  </div>
</app-default-main-layout>
